import _ from "lodash";

export const getFormFieldChildrenRecursively = (formField, children = []) => {
  if (!formField.children) return children;

  formField.children.forEach((child) => {
    children.push(_.omit(child, "children"));
    if (child.children) return getFormFieldChildrenRecursively(child, children);
  });

  return getFormFieldChildrenRecursively(formField.children, children);
};
